import template from './locationFilters.html';
import controller from './locationFilters.controller';
import './locationFilters.scss';

let locationFiltersComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default locationFiltersComponent;
